'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _normalizers;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _reactScroll = require('react-scroll');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _publish = require('../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _PublishNewHomesForm = require('./PublishNewHomesForm.scss');var _PublishNewHomesForm2 = _interopRequireDefault(_PublishNewHomesForm);
var _constants = require('./constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var normalizers = (_normalizers = {}, _normalizers[
_constants.PROJECT_FIELDS_NAMES.apartments] = _publish2.default.apartments, _normalizers[
_constants.PROJECT_FIELDS_NAMES.buildings] = _publish2.default.apartments, _normalizers[
_constants.PROJECT_FIELDS_NAMES.floors] = _publish2.default.apartments, _normalizers);var


ProjectInformation = function (_Component) {_inherits(ProjectInformation, _Component);function ProjectInformation() {var _temp, _this, _ret;_classCallCheck(this, ProjectInformation);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    renderInput = function (_ref) {var input = _ref.input,meta = _ref.meta,placeholder = _ref.placeholder;return (
        _react2.default.createElement('input', _extends({},
        input, {
          type: 'text',
          placeholder: placeholder || input.placeholder,
          inputMode: 'numeric',
          className: (0, _classnames2.default)(_PublishNewHomesForm2.default.inputNumb, _PublishNewHomesForm2.default.numeric, _PublishNewHomesForm2.default.input,
          { not_valid: meta.touched && meta.error && !meta.active }) })));}, _temp), _possibleConstructorReturn(_this, _ret);}ProjectInformation.prototype.



  render = function render() {var
    name = this.props.name;

    return (
      _react2.default.createElement('div', { className: _PublishNewHomesForm2.default.requiredFieldWrapper },
        _react2.default.createElement('span', { className: _PublishNewHomesForm2.default.label },
          this.props.translate('addNewProject', name),
          _react2.default.createElement('span', { className: 'req' }, '*')),

        _react2.default.createElement('div', { className: 'fieldset' },
          _react2.default.createElement(_reactScroll.Element, { name: name },
            _react2.default.createElement(_reduxForm.Field, {
              props: {
                locale: this.props.locale,
                placeholder: this.props.translate('addNewProject', name) },

              name: name,
              component: this.renderInput,
              normalize: normalizers[name] })))));





  };return ProjectInformation;}(_react.Component);exports.default =


ProjectInformation;

ProjectInformation.propTypes = {
  name: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  placeholder: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PublishNewHomesForm/ProjectInformation.js
// module id = 3001
// module chunks = 0